module.exports = __webpack_public_path__ + "img/google-pay.e988885a.svg";